/**
 * Custom Theme Configuration
 *
 * To toggle theme: rename themes/custom/ folder to themes/custom.bak/
 * (themes/custom/ is gitignored for personal customization)
 *
 * NOTE: All color/theme CSS variables are defined in colors.scss
 * This file only contains non-CSS resources like logo components.
 */

import { ReactComponent as NkyoSVG } from '../../../assets/icons/nkyo.svg';

const customTheme = {
    // Logo component (React SVG)
    logoComponent: NkyoSVG,
};

export default customTheme;
